import '../styles/Grille.css';

function GrilleSword({rows, swordNow}) {
    console.log('rows', rows, 'swordNow', swordNow)

    return (
		<div className="grille">
            {rows.map(({ rowsLength, id_epee, nom_epee, acronyme_jeu, image_epee }) => {
                return (
                    <div className="grille-row-large" key={rowsLength}>
                        <div className={`grille-cell-large ${id_epee === swordNow.id_epee ? 'green' : 'red'}`} >
                            <div className='grille-cell-large-detail' key={id_epee}>
                                <span className='grille-cell-large-detail-img'><img src={`/images/swords/${image_epee}`} alt={nom_epee} /></span>
                                <span className='grille-cell-large-detail-nom'>{nom_epee} ({acronyme_jeu})</span>
                            </div>
                        </div>
                    </div>
                );
            })}
        </div>
	)
}

export default GrilleSword
